// extracted by mini-css-extract-plugin
export var deleteModal = "_ik-0";